import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';
import { CardValidateComponent } from '../../card-validate/card-validate.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { Router } from '@angular/router';
import { OtpVerificationComponent } from 'src/app/components/shared/otp-verification/otp-verification.component';

export const COUNTRY_CODES = [
  { name: 'Alemania', code: '49', flag: '🇩🇪' },
  { name: 'Argelia', code: '213', flag: '🇩🇿' },
  { name: 'Argentina', code: '54', flag: '🇦🇷' },
  { name: 'Austria', code: '43', flag: '🇦🇹' },
  { name: 'Bélgica', code: '32', flag: '🇧🇪' },
  { name: 'Bolivia', code: '591', flag: '🇧🇴' },
  { name: 'Brasil', code: '55', flag: '🇧🇷' },
  { name: 'Camerún', code: '237', flag: '🇨🇲' },
  { name: 'Canadá', code: '1', flag: '🇨🇦' },
  { name: 'Chile', code: '56', flag: '🇨🇱' },
  { name: 'Colombia', code: '57', flag: '🇨🇴' },
  { name: 'Costa de Marfil', code: '225', flag: '🇨🇮' },
  { name: 'Costa Rica', code: '506', flag: '🇨🇷' },
  { name: 'Dinamarca', code: '45', flag: '🇩🇰' },
  { name: 'Ecuador', code: '593', flag: '🇪🇨' },
  { name: 'Egipto', code: '20', flag: '🇪🇬' },
  { name: 'El Salvador', code: '503', flag: '🇸🇻' },
  { name: 'España', code: '34', flag: '🇪🇸' },
  { name: 'Estados Unidos', code: '1', flag: '🇺🇸' },
  { name: 'Etiopía', code: '251', flag: '🇪🇹' },
  { name: 'Finlandia', code: '358', flag: '🇫🇮' },
  { name: 'Francia', code: '33', flag: '🇫🇷' },
  { name: 'Ghana', code: '233', flag: '🇬🇭' },
  { name: 'Grecia', code: '30', flag: '🇬🇷' },
  { name: 'Guatemala', code: '502', flag: '🇬🇹' },
  { name: 'Honduras', code: '504', flag: '🇭🇳' },
  { name: 'Irlanda', code: '353', flag: '🇮🇪' },
  { name: 'Italia', code: '39', flag: '🇮🇹' },
  { name: 'Kenia', code: '254', flag: '🇰🇪' },
  { name: 'Marruecos', code: '212', flag: '🇲🇦' },
  { name: 'México', code: '52', flag: '🇲🇽' },
  { name: 'Nicaragua', code: '505', flag: '🇳🇮' },
  { name: 'Nigeria', code: '234', flag: '🇳🇬' },
  { name: 'Noruega', code: '47', flag: '🇳🇴' },
  { name: 'Países Bajos', code: '31', flag: '🇳🇱' },
  { name: 'Panamá', code: '507', flag: '🇵🇦' },
  { name: 'Paraguay', code: '595', flag: '🇵🇾' },
  { name: 'Perú', code: '51', flag: '🇵🇪' },
  { name: 'Polonia', code: '48', flag: '🇵🇱' },
  { name: 'Portugal', code: '351', flag: '🇵🇹' },
  { name: 'Puerto Rico', code: '1', flag: '🇵🇷' },
  { name: 'Reino Unido', code: '44', flag: '🇬🇧' },
  { name: 'Rep. Dominicana', code: '1', flag: '🇩🇴' },
  { name: 'Senegal', code: '221', flag: '🇸🇳' },
  { name: 'Sudáfrica', code: '27', flag: '🇿🇦' },
  { name: 'Suecia', code: '46', flag: '🇸🇪' },
  { name: 'Suiza', code: '41', flag: '🇨🇭' },
  { name: 'Tanzania', code: '255', flag: '🇹🇿' },
  { name: 'Túnez', code: '216', flag: '🇹🇳' },
  { name: 'Turquía', code: '90', flag: '🇹🇷' },
  { name: 'Uganda', code: '256', flag: '🇺🇬' },
  { name: 'Uruguay', code: '598', flag: '🇺🇾' },
  { name: 'Venezuela', code: '58', flag: '🇻🇪' },
];

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {
  isMobile: boolean = false;
  showMenu: boolean = true;

  editAccount: boolean = false;
  editInterest: boolean = false;

  urlImages: string = AppSettings.MEDIA_URI + '/users_images/';
  profile!: any;
  userForm: FormGroup;
  valueInit: any;

  hidden: boolean = false;
  hidden2: boolean = false;

  imgControl: FormControl = new FormControl(null);
  imgName: string = '';
  changed: boolean = false;
  changedEmail: boolean = false;
  changedImg: boolean = false;
  enabledPassword: boolean = true;
  editingField: { [key: string]: boolean } = {
    nombre: false,
    movil: false,
  };

  countryCodes = COUNTRY_CODES;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private auth: AuthenticationService,
    private location: Location,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: [],
      countryCode: [{ value: '34', disabled: true }],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(9),
        ],
      ],
      birthday: [],
    });
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 700;
    this.updateMenuVisibility(this.router.url);

    this.auth.getMyData().subscribe({
      next: (data) => {
        if (data) {
          this.profile = data;
          this.auth.setProfile(data);
          this.loadProfileData();

          // FORZAMOS EL ESTADO INICIAL AQUÍ
          this.changed = false;
          this.userForm.markAsPristine();
        }
      },
    });

    this.userForm.valueChanges.subscribe(() => {
      // 1. Capturamos TODO (incluyendo countryCode)
      const currentValues = this.userForm.getRawValue();

      // 2. Comparamos solo las llaves que nos interesan para evitar ruidos de datos
      const hasChanges =
        currentValues.name !== this.valueInit.name ||
        currentValues.phone !== this.valueInit.phone ||
        currentValues.countryCode !== this.valueInit.countryCode;

      this.changed = hasChanges || this.changedImg;

      // Lógica de email
      this.changedEmail = currentValues.email != this.profile.email;
    });
  }

  loadProfileData() {
    const fullPhone = this.profile.phone || '';
    let countryCode = '34';
    let phoneNumber = fullPhone;

    const matchedCountry = this.countryCodes
      .sort((a, b) => b.code.length - a.code.length)
      .find((c) => fullPhone.startsWith(c.code));

    if (matchedCountry) {
      countryCode = matchedCountry.code;
      phoneNumber = fullPhone.substring(matchedCountry.code.length);
    }

    this.valueInit = {
      name: this.profile.name || '',
      email: this.profile.email || '',
      countryCode: countryCode,
      phone: phoneNumber,
      birthday: this.profile.birthday || null,
    };

    // Usamos patchValue pero forzamos la actualización del estado
    this.userForm.patchValue(this.valueInit, { emitEvent: true });

    // IMPORTANTE: Después de parchar, validamos manualmente para quitar el error 'required'
    this.userForm.get('phone')?.updateValueAndValidity();
    this.userForm.markAsPristine();

    this.changed = false;
    this.editingField = { name: false, phone: false };
    this.userForm.get('countryCode')?.disable();

    // Sin foto no se pinta nada en el control: el avatar enseña entonces las
    // iniciales, como en el diseño. Antes salía la imagen por defecto, que es
    // el logo de Citylok, y parecía que la foto del usuario era el logo.
    if (this.profile.image) {
      this.imgControl.setValue(this.urlImages + this.profile.image);
    } else {
      this.imgControl.setValue(null);
    }
  }

  /**
   * Las iniciales del avatar sin foto: la primera letra de las dos primeras
   * palabras del nombre ("Laura Martínez" → "LM"). Una sola si el nombre es
   * de una palabra, y nada si no hay nombre, que el hueco rosa ya se entiende.
   */
  /**
   * El teléfono como se lee: prefijo y número agrupados. Los móviles de 9
   * cifras van de tres, dos, dos y dos ("666 12 34 56"), que es como se dicta
   * un número en España; cualquier otro largo, de tres en tres.
   */
  get phoneDisplay(): string {
    const cifras = String(this.userForm?.get('phone')?.value || '').replace(/\D/g, '');
    if (!cifras) {
      return '';
    }

    const agrupado = cifras.length === 9
      ? cifras.replace(/^(\d{3})(\d{2})(\d{2})(\d{2})$/, '$1 $2 $3 $4')
      : (cifras.match(/.{1,3}/g) || []).join(' ');

    const prefijo = this.userForm?.get('countryCode')?.value;
    return prefijo ? `+${prefijo} ${agrupado}` : agrupado;
  }

  get initials(): string {
    const nombre = String(this.userForm?.get('name')?.value || this.profile?.name || '').trim();

    return nombre
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(palabra => palabra.charAt(0).toLocaleUpperCase('es'))
      .join('');
  }

  goBack() {
    localStorage.setItem('previousUrl', this.router.url);
    this.location.back();
  }

  async onFileChange(event: any) {
    let filePath = '';
    const reader = new FileReader();
    let files = event.target.files;

    if (files && files.length) {
      let file = files[0];

      // Solo los tres formatos que acepta la API (ver
      // Functions::getImgAndExtensionFromB64). Antes valía cualquier `image/*`:
      // un GIF o un HEIC pasaba aquí, no se comprimía y la API lo rechazaba al
      // guardar, con un error que no decía qué había pasado.
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: true,
            text: 'No podemos usar este tipo de archivo. Prueba con una foto en JPG o PNG.',
            btnCancel: false,
          },
        });
        event.target.value = '';
        return;
      }

      const maxSize = 10 * 1024 * 1024; // 10 MB

      try {
        file = await this.compressImage(file);
      } catch (e) {
        console.error('Error comprimiendo:', e);
      }

      if (file.size > maxSize) {
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: true,
            text: 'La imagen no puede pesar más de 10 MB.',
            btnCancel: false,
          },
        });
        event.target.value = '';
        return;
      }

      reader.readAsDataURL(file);
      reader.onload = () => {
        filePath = reader.result as string;
        this.imgName = file.name;
        this.imgControl.setValue(filePath);
        this.changedImg = true;
        this.changed = true;
      };
    }

    // Si cancela la subida, restauramos la imagen anterior
    if (!files || files.length === 0) {
      if (this.profile && this.profile.image) {
        this.imgControl.setValue(this.urlImages + this.profile.image);
      } else {
        this.imgControl.setValue(null); // sin foto: iniciales
      }
    }
  }

  async compressImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      // Si NO es una imagen estándar, devolvemos el original sin comprimir
      if (!file.type.match(/image\/(jpeg|png|webp)/)) {
        resolve(file);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const MAX_WIDTH = 1920;
          const MAX_HEIGHT = 1080;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              } else {
                resolve(file);
              }
            },
            'image/jpeg',
            0.7,
          );
        };
        img.onerror = (error) => reject(error);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  saveImg() {
    if (
      this.imgControl.value &&
      this.imgControl.value.startsWith('data:image')
    ) {
      const base64 = this.imgControl.value;
      const block = base64.split(';');
      const contentType = block[0].split(':')[1];
      const realData = block[1].split(',')[1];

      const blob = this.b64toBlob(realData, contentType);
      const formData = new FormData();
      formData.append('image', blob, this.imgName || 'profile.jpg');

      this.userService
        .uploadFilePut({ image: base64 }, this.profile.id)
        .subscribe({
          next: (res) => {
            if (res) {
              this.profile.image = res.image || this.profile.image;
              this.auth.setProfile(this.profile);
              this.changedImg = false; // Agregado para limpiar el flag
              this.openInfoCard();
            } else {
              this.openError();
            }
          },
          error: () => {
            this.openError();
          },
        });
    } else {
      this.openInfoCard();
    }
  }

  b64toBlob(
    b64Data: string,
    contentType: string = '',
    sliceSize: number = 512,
  ): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  openChangePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      panelClass: 'info-dialog',
      width: '400px',
      data: {
        user: this.profile,
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res == 'changed') {
          this.openInfoCard();
        }
        if (res == 'error') {
          this.dialog.open(InfoCardComponent, {
            panelClass: 'info-dialog',
            data: {
              icon: true,
              text: '¡Vaya! Ha ocurrido un error.',
              btnCancel: false,
            },
          });
        }
      },
    });
  }

  changeEmail() {
    if (
      this.userForm.controls['email'].value != this.profile.email &&
      !this.changedEmail
    ) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: {
          icon: true,
          text: '¿Estás seguro de que quieres actualizar el correo electrónico? Se cerrará sesión al guardar los cambios.',
          btnCancel: true,
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.changedEmail = res;
        if (!res) {
          this.userForm.controls['email'] = this.profile.email;
        }
      });
    }
  }

  saveChanges() {
    const formValues = this.userForm.getRawValue();

    // Si solo cambió la imagen (y no hay lápices activos), vamos directo
    if (
      this.changedImg &&
      !this.editingField['name'] &&
      !this.editingField['phone']
    ) {
      this.executeUserUpdate(formValues);
      return;
    }

    // 1. Identificamos qué campo se está editando actualmente
    const fieldEditing = Object.keys(this.editingField).find(
      (key) => this.editingField[key],
    );

    // 2. Si hay un campo en edición, validamos solo ese control
    if (fieldEditing) {
      const control = this.userForm.get(fieldEditing);

      if (control?.invalid) {
        control.markAsTouched(); // Muestra el error solo en el campo activo
        console.error(`El campo ${fieldEditing} es inválido`);
        return;
      }
    }

    // 3. Lógica específica según el campo que se está guardando
    if (this.editingField['phone']) {
      const currentFullPhone = `${formValues.countryCode}${formValues.phone}`;
      const phoneChanged = currentFullPhone !== this.profile.phone;

      if (phoneChanged) {
        this.userService.sendSMS(currentFullPhone).subscribe({
          next: (res) => {
            if (res.success) {
              this.openOtpModal(currentFullPhone);
            } else {
              this.openError(res.message);
            }
          },
          error: () => this.openError(),
        });
        return; // Salimos para esperar el OTP
      }
    }

    // 4. Si es el nombre o la imagen (o el teléfono no cambió), actualizamos
    this.executeUserUpdate(formValues);
  }

  openOtpModal(phone: string) {
    const dialogRef = this.dialog.open(OtpVerificationComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: { phone: phone },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'verified') {
        // 2. Solo si el OTP fue correcto, guardamos en la base de datos
        const formValues = this.userForm.getRawValue();
        this.executeUserUpdate(formValues);
      }
    });
  }

  executeUserUpdate(formValues: any) {
    const dataToUpdate: any = {};

    if (this.editingField['name']) dataToUpdate.name = formValues.name;

    if (this.editingField['phone']) {
      dataToUpdate.phone = `${formValues.countryCode}${formValues.phone}`;
    }

    if (this.changedImg && this.imgControl.value) {
      dataToUpdate.image = this.imgControl.value;
    }

    this.userService.putUser(this.profile.id, dataToUpdate).subscribe({
      next: (res) => {
        // 1. Validamos éxito y existencia de los datos en 'message'
        if (res && res.success && res.message) {
          // Añadimos un parámetro de caché para forzar recarga de la imagen en el navbar y en el perfil
          const updatedMessage = { ...res.message };
          if (updatedMessage.image) {
            updatedMessage.image = `${updatedMessage.image}?v=${Date.now()}`;
          }

          // 2. Actualizamos el perfil local y el observable global
          this.profile = { ...this.profile, ...updatedMessage };
          this.auth.setProfile(this.profile);

          // Limpiamos estados de edición
          this.editingField = { name: false, phone: false };
          this.userForm.get('countryCode')?.disable();
          this.changedImg = false;
          this.changed = false;

          this.openInfoCard();

          // 3. Recargamos la data para sincronizar 'valueInit' con los valores nuevos
          this.loadProfileData();
        } else {
          this.openError();
        }
      },
      error: () => this.openError(),
    });
  }

  openInfoCard() {
    this.changedImg = false;
    this.changed = false;
    this.changedEmail = false;
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: 'Los cambios se han guardado correctamente',
        btnCancel: false,
      },
    });
  }

  openError(message?: string) {
    this.userService.putUser(this.profile.id, this.valueInit).subscribe({
      next: (data) => {
        this.userForm.setValue(this.valueInit);
        this.imgControl.reset();
        if (this.profile.image) {
          this.imgControl.setValue(this.urlImages + this.profile.image);
        } else {
          this.imgControl.setValue(null); // sin foto: iniciales
        }
        this.changedImg = false;
        this.changed = false;
        this.changedEmail = false;
      },
    });
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: message
          ? message
          : '¡Vaya! Ha ocurrido un error inesperado, vuelva a intentarlo más tarde',
        btnCancel: false,
      },
    });
  }

  focusInput(inputElement: HTMLInputElement): void {
    inputElement.focus();
  }

  toggleEdit(field: string): void {
    this.editingField[field] = !this.editingField[field];

    if (field === 'phone') {
      const countryControl = this.userForm.get('countryCode');
      this.editingField[field]
        ? countryControl?.enable()
        : countryControl?.disable();
    }

    if (!this.editingField[field]) {
      // Restauramos el valor original del campo al cancelar
      this.userForm.get(field)?.setValue(this.valueInit[field]);
    } else {
      setTimeout(() => {
        document.getElementById(`input-${field}`)?.focus();
      });
    }
  }

  isEditing(field: string): boolean {
    return !!this.editingField[field];
  }

  deleteAccount() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.',
        btnCancel: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.userService.deleteUser(this.profile.id).subscribe({
          next: (res) => {
            if (res) {
              this.auth.logout();
            } else {
              this.dialog.open(InfoCardComponent, {
                panelClass: 'info-dialog',
                data: {
                  icon: true,
                  text: '¡Vaya! Ha ocurrido un error al eliminar la cuenta.',
                  btnCancel: false,
                },
              });
            }
          },
        });
      }
    });
  }

  // openValidatePhone() {
  //   const dialogRef = this.dialog.open(CardValidateComponent, {
  //     panelClass: 'info-dialog',
  //     data: {
  //       title: 'Cambiar número de teléfono',
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe({
  //     next: (res) => {
  //       if (res && res == 'validate') {
  //         const dialogConfirm = this.dialog.open(InfoCardComponent, {
  //           panelClass: 'info-dialog',
  //           data: {
  //             icon: false,
  //             text: 'El teléfono se ha verificado correctamente.',
  //             btnCancel: false,
  //           },
  //         });
  //         dialogConfirm.afterClosed().subscribe(() => location.reload());
  //       }
  //     },
  //   });
  // }

  updateMenuVisibility(url: string) {
    if (this.isMobile) {
      this.showMenu = url === '/profile';
    } else {
      this.showMenu = true;
    }
  }

  closeInterest(event: any) {
    this.editInterest = !event;
  }

  closeAccount() {
    this.editAccount = false;
  }

  getSelectedCountryFlag(): string {
    const code = this.userForm.get('countryCode')?.value;
    const country = this.countryCodes.find((c) => c.code === code);
    return country ? country.flag : '';
  }
}
